import React, {useState} from "react";
import {supabase} from "../../supabase";
import {useTranslation} from "react-i18next";
import AuthLogo from "./AuthLogo";
import {Row} from "../../components/styled";
import {
    Box,
    Button,
    Card,
    CardContent,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import {useNavigate} from "react-router-dom";

export default function () {
    const theme = useTheme();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [reveal, setReveal] = useState<boolean>(false);
    const [submitted, setSubmitted] = useState(false)

    async function register() {
        setLoading(true);
        try {
            const {data: {user}, error} = await supabase.auth.signUp({
                email: email,
                password: password,
            });
            setLoading(false);
            if (!error && !user) {
                alert(t("auth.checkMailLogin"));
                return;
            }
            if (error) {
                alert(error.message);
                return
            }

            setSubmitted(true)

        } catch (e) {
            console.error(e)
        }
    }

    return <Card sx={{
        minWidth: 300,
        textAlign: "center",
        opacity: 0.95
    }}>
        <CardContent>

        <AuthLogo/>
        {!submitted && <Box
        >
            <Typography
                variant="h3"
            >
                {t("auth.createAccount")}
            </Typography>
            <Typography variant={"body2"}>{t("std.email")}</Typography>
            <TextField
                variant={"outlined"}
                placeholder={t("auth.emailPlaceholder")}
                value={email}
                sx={{width: "100%"}}
                autoCapitalize="none"
                autoComplete="email"
                onChange={(e) => setEmail(e.target.value)}
            />
            <Typography variant={"body2"}>{t("auth.password")}</Typography>
            <TextField
                variant={"outlined"}
                placeholder={t("auth.passwordPlaceholder")}
                value={password}
                sx={{width: "100%"}}
                autoCapitalize="none"
                autoComplete="password"
                type={reveal ? "text" : "password"}
                slotProps={{
                    input: {
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                aria-label={
                                    reveal ? 'hide the password' : 'display the password'
                                }
                                onClick={() => setReveal(!reveal)}
                                edge="end"
                            >
                                {reveal ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </InputAdornment>
                    }
                }}
                onChange={(e) => setPassword(e.target.value)}
            />
            <Box sx={{mt: "0.5em"}}>

            <Button
                onClick={register}
                variant={"contained"}
sx={{width: "100%"}}
                disabled={loading}
            >{loading ? t("std.loading") : t("auth.createAccount")}
            </Button>
            </Box>
        </Box>}
        {submitted && <>
            <Row style={{
                marginTop: 32,
                marginBottom: 48,
                alignItems: "center",
                justifyContent: "center",
            }}>
                <Typography
                    variant={"h5"}
                    style={{textAlign: "center"}}>
                    {t("auth.checkMailLogin")}
                </Typography>
            </Row>
            <Button onClick={() => {
                setPassword("")
                setEmail("")
                setSubmitted(false)
            }}>
                {t("std.back")}
            </Button>
        </>}
            <Typography component={"span"} variant={"body2"}>{t("auth.haveAccount")}</Typography>
            <Button
                onClick={() => {
                    navigate("/Login");
                }}
            >
                {t("auth.loginHere")}
            </Button>

        </CardContent>

    </Card>;
}
